var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-login-page-div" }, [
    _c("div", { staticClass: "mobile-login-page-div-header" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: _vm._f("imgFormat")(_vm.logo) },
      }),
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 50 500 35",
            preserveAspectRatio: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              fill: "#fff",
              d: "M 0 70 Q 87.5 47, 175 70 T 350 75 T 500 70 V 100 H 0 V 0",
            },
          }),
        ]
      ),
      _vm._m(0),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isTelephoneLogin,
            expression: "!isTelephoneLogin",
          },
        ],
        staticClass: "mobile-login-page-div-body",
        style: _vm.bodyStyle,
      },
      [
        _c(
          "div",
          { staticClass: "login-page-input-content" },
          [
            _c("van-field", {
              staticClass: "input-content-item",
              attrs: { placeholder: _vm.usernamePlaceholder },
              model: {
                value: _vm.loginName,
                callback: function ($$v) {
                  _vm.loginName = $$v
                },
                expression: "loginName",
              },
            }),
            _c("van-field", {
              staticClass: "input-content-item input-content-margin",
              attrs: { type: "password", placeholder: _vm.passwordPlaceholder },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
            _c(
              "div",
              { staticClass: "input-content-verify input-content-margin" },
              [
                _c("van-field", {
                  staticClass: "input-content-item",
                  attrs: { placeholder: _vm.verifyPlaceholder },
                  model: {
                    value: _vm.code,
                    callback: function ($$v) {
                      _vm.code = $$v
                    },
                    expression: "code",
                  },
                }),
                _c("img", {
                  staticClass: "input-content-verifyimg",
                  attrs: { src: _vm.codeUrl, alt: "" },
                  on: { click: _vm.updateCodeUrl },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "login-page-submit-button",
            class:
              _vm.loginName.length == 0 ||
              _vm.password.length == 0 ||
              _vm.code.length == 0
                ? "login-page-submit-button-disable"
                : "",
            on: { click: _vm.submitByUsername },
          },
          [_vm._v(" 确定 ")]
        ),
        _c("div", { staticClass: "login-page-forget-content" }, [
          _vm.hasForgetPwd
            ? _c(
                "div",
                {
                  staticClass: "login-page-forget-button",
                  on: { click: _vm.forgetButtonFunction },
                },
                [_vm._v(" 忘记密码? ")]
              )
            : _vm._e(),
        ]),
        _vm.hasPhoneLogin
          ? _c(
              "div",
              {
                staticClass: "login-page-exchange-button",
                on: {
                  click: function ($event) {
                    return _vm.changeLoginType(true)
                  },
                },
              },
              [_vm._v(" 验证码登录 ")]
            )
          : _vm._e(),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isTelephoneLogin,
            expression: "isTelephoneLogin",
          },
        ],
        staticClass: "mobile-login-page-div-body",
        style: _vm.bodyStyle,
      },
      [
        _c(
          "div",
          {
            staticClass:
              "login-page-input-content login-page-phone-input-content",
          },
          [
            _c("van-field", {
              staticClass: "input-content-item",
              attrs: { type: "tel", placeholder: _vm.phonePlaceholder },
              model: {
                value: _vm.phoneNumber,
                callback: function ($$v) {
                  _vm.phoneNumber = $$v
                },
                expression: "phoneNumber",
              },
            }),
            _c("van-field", {
              staticClass: "input-content-item input-content-margin",
              attrs: {
                disabled: !_vm.verifyPhoneNumber(),
                placeholder: _vm.phoneVerifyPlaceholder,
              },
              scopedSlots: _vm._u([
                {
                  key: "extra",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "input-content-send-verify",
                          on: { click: _vm.getCode },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.codeBtType != ""
                                  ? _vm.countdownTime + "s"
                                  : "获取验证码"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.phoneCode,
                callback: function ($$v) {
                  _vm.phoneCode = $$v
                },
                expression: "phoneCode",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "login-page-submit-button",
            class:
              _vm.phoneNumber.length == 0 || _vm.phoneCode.length == 0
                ? "login-page-submit-button-disable"
                : "",
            on: { click: _vm.submitByPhone },
          },
          [_vm._v(" 确定 ")]
        ),
        _vm._m(1),
        _c(
          "div",
          {
            staticClass: "login-page-exchange-button",
            on: {
              click: function ($event) {
                return _vm.changeLoginType(false)
              },
            },
          },
          [_vm._v(" 账号登录 ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ds-login-page-header-bg" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-page-forget-content" }, [
      _c("div", { staticClass: "login-page-forget-button" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }